export default "__VITE_ASSET__LxLmkj8j__"